import { api } from 'helpers'
import { ARC_MOSAICO_ENDPOINTS } from 'api/arcMosaico'
import type { SchoolDetailsResponse, CityOption } from '../types'

function assertAuthenticated(response: { status: number }): void {
  if (response.status === 401) {
    window.location.href = '/error_permission'
    throw new Error('Unauthorized')
  }
}

export async function fetchSchoolDetails(schoolId: string): Promise<SchoolDetailsResponse> {
  const response = await api.get(ARC_MOSAICO_ENDPOINTS.schools.show(schoolId))
  assertAuthenticated(response)
  return response.data as SchoolDetailsResponse
}

export async function fetchCitiesByCountry(countryId: string): Promise<CityOption[]> {
  const response = await api.get(ARC_MOSAICO_ENDPOINTS.cities.list, {
    params: { countryId },
  })
  assertAuthenticated(response)
  const data = response.data as { cities: CityOption[] }
  return data.cities || []
}

export async function updateSchool(
  schoolId: string,
  data: { name: string; zipcode: string; cityId: string | null }
): Promise<void> {
  const response = await api.put(
    ARC_MOSAICO_ENDPOINTS.schools.update(schoolId),
    { name: data.name, zipcode: data.zipcode, cityId: data.cityId }
  )
  assertAuthenticated(response)
}
